<div>
  <div class="tabs border-bottom container-fluid">
    <span (click)="handleRefreshTable()" class="com-tab refresh">
      <i class="fa fa-refresh" aria-hidden="true"></i>
    </span>
    <a class="tab-link com-tab active" (click)="openCity($event, 'unpaid')">Unpaid commissions</a>
    <a class="tab-link com-tab" (click)="openCity($event, 'paid')">Commision payments</a>
  </div>

  <div class="container-fluid">
    <div id="unpaid" class="tcontent">
      <div class="spinner d-block w-100 py-5 text-center" *ngIf="isLoadingCommissions">
        <span class="spinner-border spinner-border-md mx-auto" role="status"></span>
      </div>
      <div *ngIf="!isLoadingCommissions">
        <div class=" row m-2" *ngIf="agentsCommissionsData?.length>0">
          <div class="col pl-0">
            <input 
              type="text" 
              placeholder="Search agent"
              name="searchAgentCommissions"
              (keyup)="filterAgentCommissions($event)"
              class="px-2 py-1"
            >
          </div>
          <div class="col-md-5 bold pt-1">
            Total Amount: UGX {{totalAmount | number}}
          </div>
          <div class="col-md-3">
          </div>
          <div class="col">
            <button
              type="button"
              class="btn btn-outline-dark pay-btn"
              data-toggle="modal"
              data-target="#bulkPayModal"
              [disabled]="!(bulkPaymentsData.length>1)"
              (click)="setBulkPayData()"
            >
              Bulk Pay
            </button>
          </div>
        </div>
        <div *ngIf="agentsCommissionsData?.length===0" style="text-align: center;">
          No agent commissions data...
        </div>
        <div *ngIf="agentsCommissionsDataFilter?.length===0" style="text-align: center;">
          No agent found...
        </div>
        <div *ngIf="agentsCommissionsDataFilter?.length>0">
          <table class="table table-bordered table-primary" id="commissionsTable">
            <thead>
              <tr class="text-uppercase">
                <th>#</th>
                <th scope="col">Name</th>
                <th scope="col">Phone</th>
                <th scope="col">District</th>
                <th scope="col">Farmers</th>
                <th scope="col">Total commission</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of agentsCommissionsDataFilter | paginate: { id: 'paginate1', itemsPerPage: count, currentPage: upPage };
              let i = index">
                <td>{{ (upPage - 1) * count + i + 1 }}</td>
                <td>
                  <a
                    class="bold text-primary"
                    data-toggle="modal"
                    data-target="#transactionHistoryModal"
                    (click)="loadTransactionHistory(row)"
                  >
                    {{row.va_name}}
                  </a>
                  </td>
                <td>{{row.va_phonenumber}}</td>
                <td>{{row.district}}</td>
                <td>{{row.farmers}}</td>
                <td class="bold">{{row.commission | number}}</td>
                <td>
                  <button
                    type="button"
                    class="btn btn-outline-dark pay-btn"
                    data-toggle="modal"
                    data-target="#payCommisssionModal"
                    (click)="setSingleCommissionData(row)"
                    [disabled]="!(row.momoName&&row.momoPhone) || 
                    row.commission===0 || bulkPaymentsData.length>0"
                  >
                    Pay now
                  </button>
                </td>
                <td>
                  <div class="custom-control custom-checkbox">
                    <input 
                      type="checkbox" 
                      class="custom-control-input" 
                      id="{{ (upPage - 1) * count + i + 1 }}" 
                      (change)="onCheckedChange($event, row)"
                      [disabled]="!(row.momoName&&row.momoPhone) || row.commission===0"
                    >
                    <label class="custom-control-label" for="{{ (upPage - 1) * count + i + 1 }}"></label>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <nav>
            <pagination-controls id="paginate1" (pageChange)="upPage = $event"></pagination-controls>
          </nav>
        </div>
      </div>
    </div>
  
    <div id="paid" class="tcontent" style="display: none;">
      <div class="spinner d-block w-100 py-5 text-center" *ngIf="isLoadingPayments">
        <span class="spinner-border spinner-border-md mx-auto" role="status"></span>
      </div>
      <div *ngIf="!isLoadingPayments">
        <div class="row m-2" *ngIf="paymentsData?.length>0">
          <div class="col pl-0">
            <input 
              type="text" 
              placeholder="Search agent"
              name="searchAgentPayments"
              (keyup)="filterPayments($event)"
              class="px-2 py-1"
            >
          </div>
          <div class="col">
            <p-calendar 
              #range_Dates="ngModel" 
              id="rangeDates" 
              [(ngModel)]="rangeDates"
              yearRange="2000:2030" 
              selectionMode="range" 
              [monthNavigator]="true"
              [yearNavigator]="true" 
              [readonlyInput]="true" 
              [showButtonBar]="true"
              placeholder="Startdate - Enddate"
              inputStyleClass="date-range"
              (onSelect)="onDateRangeSelected()"
              (onClose)="onDateRangeSelected()"
              dateFormat="dd/mm/yy"
              #calendar
            >
            <p-footer>
              <div>
                <button 
                  [disabled]='!rangeDates' 
                  class="btn btn-primary btn-small"
                  (click)="onDateRangeSelected();calendar.hideOverlay()"
                >Ok</button>
              </div>
            </p-footer>
            </p-calendar>
          </div>
          <div class="col-md-5 bold pt-1">
            Total Payments: UGX {{totalPayments | number}}
          </div>
          <div class="col-md-3">
          </div>
        </div>
        <div *ngIf="paymentsData?.length===0" style="text-align: center;">
          No payments made yet...
        </div>
        <div *ngIf="paymentsDataFilter?.length===0" style="text-align: center;">
          No data found...
        </div>
        <div *ngIf="paymentsDataFilter?.length>0">
          <table class="table table-bordered table-primary" id="paymentsTable">
            <thead>
              <tr class="text-uppercase">
                <th>#</th>
                <th scope="col">Name</th>
                <th scope="col">Phone</th>
                <th scope="col">District</th>
                <th scope="col">Farmers</th>
                <th scope="col">Date</th>
                <th scope="col">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of paymentsDataFilter | paginate: { id: 'paginate2', itemsPerPage: count, currentPage: pPage };
              let i = index">
                <td>{{ (pPage - 1) * count + i + 1 }}</td>
                <td>{{row.va_name}}</td>
                <td>{{row.va_phonenumber}}</td>
                <td>{{row.district}}</td>
                <td>{{row.farmers}}</td>
                <td>{{row.created_at | date: 'dd/MM/yyyy'}}</td>
                <td class="bold text-primary">{{row.commission | number}}</td>
              </tr>
            </tbody>
          </table>
          <nav>
            <pagination-controls id="paginate2" (pageChange)="pPage = $event"></pagination-controls>
          </nav>
        </div>
      </div>
    </div>
  </div>

  <!-- Pay commission modal -->
  <div class="modal fade" id="payCommisssionModal" tabindex="-1" role="dialog" aria-labelledby="payCommisssionModal"
  aria-hidden="true" style="overflow: auto;">
    <div class="modal-dialog modal-md" role="document" (click)="onClickOutside()">
      <div class="modal-content container-fluid">
        <div class="modal-header no-border">
          <h5 class="modal-title text text-primary" style="font-weight: bold;">Commissions Payments</h5>
          <button 
            type="button" 
            class="close close-btn"  
            aria-hidden="true" 
            data-dismiss="modal"
            (click)="closePaymentsModal()"
            >&times;</button>
        </div>
        <div class="modal-body">
          <form
            *ngIf="singleAgentCommissionsData"
            class="form"
            #makePaymentsForm="ngForm"
            (ngSubmit)="makePayment(makePaymentsForm.value)"
            id="makePaymentForm"
          >
            <div>
              <div class="form-group">
                <h3>{{ singleAgentCommissionsData.momoName }}</h3>
                <h5>UGX {{ singleAgentCommissionsData.commission | number}}</h5>
              </div>
              <div class="form-group">
                <label for="phone">Phone</label>
                <input
                  type="tel"
                  class="form-control"
                  [(ngModel)]="singleAgentCommissionsData.momoPhone"
                  [ngModelOptions]="{standalone: true}"
                  readonly
                >
              </div>
              <div class="form-group">
                <label for="amount">Amount</label>
                  <input
                    id="amount"
                    type="number"
                    class="form-control"
                    name="amount"
                    #amount="ngModel"
                    [(ngModel)]="commissionAmount"
                    required
                  >
                  <div
                  *ngIf="amount.touched && !amount.valid"
                  class="text-danger error_message"
                  >
                    <span *ngIf="amount.hasError('required')">
                      Please the amount is required
                    </span>
                  </div>
                  <div
                  *ngIf="amount.value>singleAgentCommissionsData.commission"
                  class="text-danger error_message"
                  >
                    <span>
                      Amount can not be more than the commission!
                    </span>
                  </div>
              </div>
              <div class="form-group">
                <label for="balance">Balance after payment</label>
                <div *ngIf="!(amount.hasError('required') || 
                  amount.value>singleAgentCommissionsData.commission);else invalid">
                  <h4>
                    UGX {{(singleAgentCommissionsData.commission - amount.value) | number}}
                  </h4>
                </div>
                <ng-template #invalid><h4>UGX 0</h4></ng-template>
              </div>
            </div>
            <br>
            <div class="modal-footer no-border">
              <button 
                type="button" 
                class="btn btn-secondary" 
                data-dismiss="modal" 
                (click)="closePaymentsModal()">Cancel</button>
              <button
                type="submit"
                class="btn btn-primary float-right"
                [disabled]="!makePaymentsForm.form.valid || amountError"
              >
              <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
              </span>
              <span *ngIf="loading" class="mx-2">Loading...</span>
              <span *ngIf="!loading">
                Pay Now
              </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Transaction history modal -->
  <div class="modal fade" id="transactionHistoryModal" tabindex="-1" role="dialog" aria-labelledby="transactionHistoryModal"
    aria-hidden="true" style="overflow: auto;">
      <div class="modal-dialog modal-xl" role="document" (click)="onClickOutside()">
        <div class="modal-content container-fluid">
          <div class="modal-header no-border">
            <h5 class="modal-title text text-primary" style="font-weight: bold;">Transaction History</h5>
            <button 
              type="button" 
              class="close close-btn"  
              aria-hidden="true" 
              data-dismiss="modal"
              (click)="closeHistoryModal()"
              >&times;</button>
          </div>
          <div class="modal-body">
            <div class="spinner d-block w-100 py-5 text-center" *ngIf="isLoadingTransHistory">
              <span class="spinner-border spinner-border-md mx-auto" role="status"></span>
            </div>
            <div *ngIf="!isLoadingTransHistory">
              <div *ngIf="transactionHistoryData?.length===0" style="text-align: center;">
                No transaction history...
              </div>
              <div *ngIf="transactionHistoryDataFilter?.length>0" class="container-fluid">
                <div class="tabs mb-1">
                  <a class="tab-link trans-tab active" (click)="setTransHistoryData($event, 'garden_mapping')">Garden Mapping</a>
                  <a class="tab-link trans-tab" (click)="setTransHistoryData($event, 'payments')">Payments</a>
                </div>
                
                <table class="table table-bordered table-primary">
                  <thead>
                    <tr class="text-uppercase">
                      <th>#</th>
                      <th scope="col" [hidden]="!isGardenMappingTrans">Acreage</th>
                      <th scope="col">Amount</th>
                      <th scope="col" [hidden]="!isGardenMappingTrans">Mapping Fee</th>
                      <th scope="col" [hidden]="!isGardenMappingTrans">Commission Rate</th>
                      <th scope="col">Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let row of transactionHistoryDataFilter | paginate: { id: 'paginate3', itemsPerPage: count, currentPage: thPage };
                    let i = index">
                      <td>{{ (thPage - 1) * count + i + 1 }}</td>
                      <td [hidden]="!isGardenMappingTrans">{{row.acreage}}</td>
                      <td>{{row.amount | number}}</td>
                      <td [hidden]="!isGardenMappingTrans">{{row.mappingFee}}</td>
                      <td [hidden]="!isGardenMappingTrans">{{row.commissionRate}}</td>
                      <td>{{formatDate(row.created_at)}}</td>
                    </tr>
                  </tbody>
                </table>
                <nav>
                  <pagination-controls id="paginate3" (pageChange)="thPage = $event"></pagination-controls>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Bulk pay modal -->
  <div class="modal fade" id="bulkPayModal" tabindex="-1" role="dialog" aria-labelledby="bulkPayModal"
  aria-hidden="true" style="overflow: auto;">
    <div class="modal-dialog modal-md" role="document" (click)="onClickOutside()">
      <div class="modal-content container-fluid">
        <div class="modal-header no-border">
          <h5 class="modal-title text text-primary" style="font-weight: bold;">Bulk Commissions Payments</h5>
          <button 
            type="button" 
            class="close close-btn"  
            aria-hidden="true" 
            data-dismiss="modal"
            >&times;</button>
        </div>
        <div class="modal-body">
          <form
            class="form"
            (ngSubmit)="makeBulkPayment()"
            id="makeBulkPaymentForm"
            [formGroup]="bulkPaymentForm"
          >
            <div>
              <div class="form-group">
                <div class="bulk">
                  <div formArrayName="bulk_payments" *ngFor="let item of commissionPayments().controls; let i = index">
                    <div class="form-group" [formGroupName]="i">
                      <div class="card" style="width: 27rem;">
                        <div class="card-body">
                          <div class="form-group">
                            <h3>{{item.value.name}}</h3>
                            <h5>UGX {{item.value.totalCommissionAmount | number}}</h5>
                          </div>
                          <div class="form-group">
                            <label for="phone">Phone</label>
                            <input
                              type="tel"
                              class="form-control"
                              formControlName="phone" 
                              readonly
                            >
                          </div>
                          <div class="form-group">
                            <label for="amount">Amount</label>
                              <input
                                type="number"
                                class="form-control"
                                formControlName="amount"
                                required
                              >
                              <div
                              *ngIf="(item.controls.amount.dirty || item.controls.amount.touched)"
                              class="text-danger error_message"
                              >
                                <span *ngIf="item.controls.amount.invalid && item.controls.amount.hasError('amountError')">
                                  Amount can not be more than the commission!
                                </span>
                              </div>
                              <div
                              *ngIf="(item.controls.amount.dirty || item.controls.amount.touched)"
                              class="text-danger error_message"
                              >
                                <span *ngIf="item.controls.amount.invalid && item.controls.amount.hasError('required')">
                                  Please the amount is required
                                </span>
                              </div>
                          </div>
                          <div class="form-group">
                            <label for="balance">Balance after payment</label>
                            <div *ngIf="!item.controls.amount.errors;else not_valid">
                              <h4>
                                UGX {{(item.value.totalCommissionAmount - item.value.amount) | number}}
                              </h4>
                            </div>
                            <ng-template #not_valid><h4>UGX 0</h4></ng-template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br>
            <div class="modal-footer no-border">
              <button 
                type="button" 
                class="btn btn-secondary" 
                data-dismiss="modal" 
              >Cancel</button>
              <button
                type="submit"
                class="btn btn-primary float-right"
                [disabled]="!bulkPaymentForm.valid || amountError"
              >
              <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
              </span>
              <span *ngIf="loading" class="mx-2">Loading...</span>
              <span *ngIf="!loading">
                Pay Now
              </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
